import _ from 'lodash';
import { t } from '@lingui/macro';
import {
    AGENT_BEACON_PACKETS_INTERFACES_DISABLED_OPTION,
    AGENT_SSH_PASSWORD_FIELD,
    AGENT_SSH_PASSWORD_VALUE_FIELD,
    AGENT_VIRTUAL_INTERFACE_WIRED_COUNT_FIELD,
    AGENT_VIRTUAL_INTERFACE_WIRED_FIELD,
    AGENT_VIRTUAL_INTERFACE_WIRELESS_COUNT_FIELD,
    AGENT_VIRTUAL_INTERFACE_WIRELESS_FIELD,
    AGENT_WEB_UI_PASSWORD_FIELD,
    AGENT_WEB_UI_PASSWORD_VALUE_FIELD,
    AGENT_WEB_UI_USERNAME_FIELD,
    AGENT_WEB_UI_USERNAME_VALUE_FIELD,
    AGENT_XMS_LOCATION_FIELD,
    BEACON_PACKETS_FIELD,
    WEB_PROXY_AUTO_PROXY_OPTION,
    WEB_PROXY_AUTO_URL,
    WEB_PROXY_FIELD,
    WEB_PROXY_ID_FIELD,
    WEB_PROXY_MANUAL_PORT,
    WEB_PROXY_MANUAL_PROXY_OPTION,
    WEB_PROXY_MANUAL_SERVER_ADDRESS,
    WEB_PROXY_NO_PROXY_OPTION,
    WEB_PROXY_SELECTION_FIELD,
    AGENT_SNMP_COMMUNITY_FIELD,
    AGENT_SNMP_ENABLED_FIELD,
    AGENT_SNMP_V3_ENABLED_FIELD,
    AGENT_SSH_SELECTION_ENABLED_NGP_OPTION,
    AGENT_WEB_UI_SELECTION_ENABLED_CREDS_OPTION,
    AGENT_SNMP_V3_USER_FIELD,
    AGENT_SNMP_V3_AUTH_PASSWD_FIELD,
    AGENT_SNMP_V3_PRIV_PASSWD_FIELD,
    AGENT_SNMP_V3_AUTH_CIPHER_FIELD,
    AGENT_SNMP_V3_PRIV_CIPHER_FIELD,
    AGENT_SNMP_V3_AUTH_CIPHER_OPTIONS,
    AGENT_SNMP_V3_PRIV_CIPHER_OPTIONS,
    AGENT_WEB_UI_SELECTION_FIELD,
    AGENT_SSH_SELECTION_FIELD,
    AGENT_SNMP_V3_PRIV_PASSWD_VALUE_FIELD,
    AGENT_SNMP_V3_AUTH_PASSWD_VALUE_FIELD,
    AGENT_SNMP_TARGET_2KH_FIELD,
    AGENT_SNMP_TARGET_3KH_FIELD,
    AGENT_SNMP_TARGET_EDGE_FIELD,
    AGENT_SNMP_V3_TARGET_EDGE_FIELD,
} from './AgentSettingsConstants';
import { ID_FIELD } from '../../form/FormConstants';
import { HTTP_STATUS_400 } from '../../../services/ApiDataService';
import { MANUAL_ERROR_TYPE, unpackValidationErrors } from '../../../utilities/FormUtilities';

export function buildBeaconPackets(response) {
    if (!response[BEACON_PACKETS_FIELD] || !_.get(response, AGENT_VIRTUAL_INTERFACE_WIRED_FIELD)) {
        _.set(response, AGENT_VIRTUAL_INTERFACE_WIRED_COUNT_FIELD, AGENT_BEACON_PACKETS_INTERFACES_DISABLED_OPTION);
    }

    if (!response[BEACON_PACKETS_FIELD] || !_.get(response, AGENT_VIRTUAL_INTERFACE_WIRELESS_FIELD)) {
        _.set(response, AGENT_VIRTUAL_INTERFACE_WIRELESS_COUNT_FIELD, AGENT_BEACON_PACKETS_INTERFACES_DISABLED_OPTION);
    }
}

export function buildWebProxy(dbValue) {
    const noProxyId = 'noProxy';
    const theWebProxy = {
        [WEB_PROXY_FIELD]: {},
    };

    if (dbValue && dbValue[ID_FIELD] === noProxyId) {
        _.set(theWebProxy, WEB_PROXY_SELECTION_FIELD, WEB_PROXY_NO_PROXY_OPTION);
        return theWebProxy;
    }

    theWebProxy[WEB_PROXY_FIELD] = (_.isArray(dbValue) ? _.first(dbValue) : dbValue) || {};

    if (_.get(theWebProxy, WEB_PROXY_MANUAL_SERVER_ADDRESS)) {
        _.set(theWebProxy, WEB_PROXY_SELECTION_FIELD, WEB_PROXY_MANUAL_PROXY_OPTION);
    } else if (_.get(theWebProxy, WEB_PROXY_AUTO_URL)) {
        _.set(theWebProxy, WEB_PROXY_SELECTION_FIELD, WEB_PROXY_AUTO_PROXY_OPTION);
    }

    return theWebProxy;
}

export function prepareBeaconPackets(putData) {
    const countDefault = '0';
    // This ends up being 4 fields in the database, so we need to do some massage.
    const wiredCount = _.get(putData, AGENT_VIRTUAL_INTERFACE_WIRED_COUNT_FIELD, countDefault);
    const wirelessCount = _.get(putData, AGENT_VIRTUAL_INTERFACE_WIRELESS_COUNT_FIELD, countDefault);
    const wiredCountInt = parseInt(wiredCount, 10);
    const wirelessCountInt = parseInt(wirelessCount, 10);

    if (!putData[BEACON_PACKETS_FIELD]) {
        _.set(putData, AGENT_VIRTUAL_INTERFACE_WIRED_FIELD, false);
        _.set(putData, AGENT_VIRTUAL_INTERFACE_WIRELESS_FIELD, false);
        _.set(putData, AGENT_VIRTUAL_INTERFACE_WIRED_COUNT_FIELD, 1);
        _.set(putData, AGENT_VIRTUAL_INTERFACE_WIRELESS_COUNT_FIELD, 1);
    } else {
        // We gotta bypass some validations here as well.  Gotta be greater than 1 if you set it.
        _.set(putData, AGENT_VIRTUAL_INTERFACE_WIRED_FIELD, wiredCountInt > 0);
        _.set(putData, AGENT_VIRTUAL_INTERFACE_WIRELESS_FIELD, wirelessCountInt > 0);
        _.set(putData, AGENT_VIRTUAL_INTERFACE_WIRED_COUNT_FIELD, _.toString(_.max([1, wiredCountInt])));
        _.set(putData, AGENT_VIRTUAL_INTERFACE_WIRELESS_COUNT_FIELD, _.toString(_.max([1, wirelessCountInt])));
    }
}

export function prepareWebProxy(putData, formData) {
    prepareWebProxyFields(putData, formData);
}

function prepareWebProxyFields(putData, formData) {
    const webProxyId = _.get(formData, WEB_PROXY_ID_FIELD);
    if (webProxyId) {
        _.set(putData, WEB_PROXY_ID_FIELD, webProxyId);
    }

    if (_.get(putData, WEB_PROXY_SELECTION_FIELD) === WEB_PROXY_MANUAL_PROXY_OPTION) {
        if (!_.isEmpty(_.get(putData, WEB_PROXY_AUTO_URL))) {
            _.set(putData, WEB_PROXY_AUTO_URL, null);
        }

        return;
    }

    if (!_.isEmpty(_.get(putData, WEB_PROXY_MANUAL_SERVER_ADDRESS))) {
        _.set(putData, WEB_PROXY_MANUAL_SERVER_ADDRESS, null);
    }

    if (!_.isEmpty(_.get(putData, WEB_PROXY_MANUAL_PORT))) {
        _.set(putData, WEB_PROXY_MANUAL_PORT, null);
    }
}

export function prepareSettings(dataToSave, putData) {
    if (_.get(dataToSave, AGENT_WEB_UI_SELECTION_FIELD) !== AGENT_WEB_UI_SELECTION_ENABLED_CREDS_OPTION) {
        _.set(putData, AGENT_WEB_UI_USERNAME_FIELD, null);
        _.set(putData, AGENT_WEB_UI_PASSWORD_FIELD, null);
    }

    if (_.get(dataToSave, AGENT_SSH_SELECTION_FIELD) !== AGENT_SSH_SELECTION_ENABLED_NGP_OPTION) {
        _.set(putData, AGENT_SSH_PASSWORD_FIELD, null);
    }

    if (_.get(dataToSave, AGENT_SNMP_ENABLED_FIELD) !== true) {
        _.set(putData, AGENT_SNMP_COMMUNITY_FIELD, null);
        _.set(putData, AGENT_SNMP_TARGET_2KH_FIELD, true);
        _.set(putData, AGENT_SNMP_TARGET_3KH_FIELD, true);
        _.set(putData, AGENT_SNMP_TARGET_EDGE_FIELD, true);
    }

    if (_.get(dataToSave, AGENT_SNMP_V3_ENABLED_FIELD) !== true) {
        _.set(putData, AGENT_SNMP_V3_USER_FIELD, null);
        _.set(putData, AGENT_SNMP_V3_AUTH_CIPHER_FIELD, AGENT_SNMP_V3_AUTH_CIPHER_OPTIONS.getDefault());
        _.set(putData, AGENT_SNMP_V3_AUTH_PASSWD_FIELD, null);
        _.set(putData, AGENT_SNMP_V3_PRIV_CIPHER_FIELD, AGENT_SNMP_V3_PRIV_CIPHER_OPTIONS.getDefault());
        _.set(putData, AGENT_SNMP_V3_PRIV_PASSWD_FIELD, null);
        _.set(putData, AGENT_SNMP_V3_TARGET_EDGE_FIELD, true);
    } else if (_.get(dataToSave, AGENT_SNMP_V3_AUTH_CIPHER_FIELD) === AGENT_SNMP_V3_AUTH_CIPHER_OPTIONS.None) {
        _.set(putData, AGENT_SNMP_V3_AUTH_PASSWD_FIELD, null);
        _.set(putData, AGENT_SNMP_V3_PRIV_CIPHER_FIELD, AGENT_SNMP_V3_PRIV_CIPHER_OPTIONS.getDefault());
        _.set(putData, AGENT_SNMP_V3_PRIV_PASSWD_FIELD, null);
    } else if (_.get(dataToSave, AGENT_SNMP_V3_PRIV_CIPHER_FIELD) === AGENT_SNMP_V3_PRIV_CIPHER_OPTIONS.None) {
        _.set(putData, AGENT_SNMP_V3_PRIV_PASSWD_FIELD, null);
    }
}

export function buildBeaconInterfaceOptions() {
    const noneText = t`None`;
    return _.reduce(
        _.range(1, 11),
        (result, n) => {
            const asString = _.toString(n);
            result[asString] = asString;
            return result;
        },
        { 0: noneText }
    );
}

export function buildValidationFieldMapper() {
    const mapper = {};
    _.set(mapper, AGENT_WEB_UI_USERNAME_FIELD, AGENT_WEB_UI_USERNAME_VALUE_FIELD);
    _.set(mapper, AGENT_WEB_UI_PASSWORD_FIELD, AGENT_WEB_UI_PASSWORD_VALUE_FIELD);
    _.set(mapper, AGENT_SNMP_V3_AUTH_PASSWD_FIELD, AGENT_SNMP_V3_AUTH_PASSWD_VALUE_FIELD);
    _.set(mapper, AGENT_SNMP_V3_PRIV_PASSWD_FIELD, AGENT_SNMP_V3_PRIV_PASSWD_VALUE_FIELD);
    _.set(mapper, AGENT_SSH_PASSWORD_FIELD, AGENT_SSH_PASSWORD_VALUE_FIELD);
    return mapper;
}

export function handleAgentSettingsSaveError(errorObject, setError, fieldMapper = {}) {
    if (errorObject.getStatus && errorObject.getStatus() === HTTP_STATUS_400) {
        const validationErrors = unpackValidationErrors(errorObject.responseBody);
        const xmsLocationErrors = [];

        _.each(validationErrors, (value, key) => {
            const fieldKey = _.get(fieldMapper, key, key);
            // MDL - For encryption type fields, the field name and the value are different, so create a mapping
            //  AND, sometimes the API sends down duplicate errors for the same field like:
            //  agentWebUI and agentWebUI.username, if we create errors for both, neither will show up
            if (_.isString(fieldKey)) {
                if (key.indexOf(`${AGENT_XMS_LOCATION_FIELD}.`) > -1) {
                    xmsLocationErrors.push(value.message);
                } else {
                    setError(fieldKey, {
                        type: MANUAL_ERROR_TYPE,
                        message: value.message,
                    });
                }
            }
        });

        if (xmsLocationErrors.length > 0) {
            setError(AGENT_XMS_LOCATION_FIELD, {
                type: MANUAL_ERROR_TYPE,
                message: xmsLocationErrors.join('\r\n'),
            });
        }
    }

    throw errorObject;
}
